import { toggleModal } from '../../../reducers/modalReducer'
import Button from '../../common/Button'
import { useDispatch } from 'react-redux'

const CompanyReferOffer = ({ company }) => {
    const dispatch = useDispatch()
    return (
        <div
            className="user-info-sidebar 12 check mt12 br8px cp df py1rem px0-5rem aic mt0-5rem fdc bg1 shadow bo45 bss bw1px"
            style={{ width: "100%", paddingLeft: '0.5rem' }}
        >
            <div
                className='mb1rem'
                style={{
                    border: '1px solid #A8EFAB',
                    padding: '0.3rem 1rem',
                    borderRadius: '8px',
                    backgroundColor: '#E4FFEB'
                }}
            >
                <h2 className='fs1rem fw500 c59'>DILIGENTSIA <span className='fw700 fs1-25rem'>PLUS</span></h2>
            </div>
            <img width={150} src={require('../../../../images/companyReferOffer.png')} alt='refer' />
            <h3 className='tac c4 fs1rem mt1rem'>Get help from an <br></br> experienced CFO</h3>
            <p className='tac c14 fs13px mt0-5rem df aic'>Fixed price 4 quarterly reviews of</p>
            <p className='tac c14 fs13px mb1rem df aic'> your preparedness <img width={40} src={require('../../../../images/plus.png')} alt='refer' /> advice ​</p>
            <Button
                style={{
                    width: '120px',
                    height: '34px',
                    padding: '4px',
                    fontSize: '0.75rem',
                    textTransform: 'uppercase',
                }}
                btnType='warning'
                text={"Learn More"}
                onClick={() => dispatch(toggleModal({ open: 'companyReferCfoOfferModa' }))}
            />
        </div>
    )
}

export default CompanyReferOffer